module.exports = __webpack_public_path__ + "img/Hotmart-9-en.cbc8ebf2.png";